import useLocalState from './useLocalState';

// useLocalState but with array return
export default function useStickyState(name, defaultValue, parse = JSON.parse) {
    const { state, setState, resetState } = useLocalState(name, defaultValue, parse);

    return [state, setState, resetState];
}
